import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const CreatingSculptingPlan = lazyWithPreload(
  () => import('./CreatingSculptingPlan'),
)
